// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagina-historico.contenedorprincipal {
  width: 95%;
  margin: 0 auto;
}

.pagina-historico .titulo {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 2px;
}

.pagina-historico .botonessuperiores {
  display: flex; /* Usamos flexbox para alinear los botones */
  justify-content: center; /* Centramos los botones horizontalmente */
  gap: 5px; /* Espaciado entre los botones */
  margin-bottom: 15px; /* Espaciado inferior para separar de otros elementos */
}

.botonessuperiores .p-button {
  padding: 5px 10px; /* Reduce el padding interno de los botones */
  font-size: 14px; /* tamaño del texto de los botones*/
}

.fila-seleccionada {
  background-color: #e0f7fa !important;
}

/*************Resumen estado pedidos***************/
.resumen-estados-container {
  position: absolute;
  top: 60px;
  right: 20px;
  width: 250px;
  padding: 5px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 0.9rem;
}

/* Media query para pantallas pequeñas */
@media (max-width: 768px) {
  .resumen-estados-container {
    position: static; /* Cambia la posición a estática */
    margin-top: 20px; /* Agrega un margen superior para separar de los botones */
    width: 100%; /* Ocupa todo el ancho disponible */
  }
}

.resumen-estado-item {
  display: flex;
  align-items: center;
  gap: 8px; /* Espaciado entre el ícono y el nombre */
  padding: 2px 0;
}

/* [EXPERT] Estabilidad del paginador y alineación */
.pagina-historico .p-datatable .p-datatable-wrapper {
  min-height: 400px;
}

.pagina-historico .p-datatable .p-datatable-thead > tr > th {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.35rem !important;
}

.pagina-historico .p-datatable .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.3rem !important;
  height: 38px !important;
}

/* ============================================
   MEDIA QUERIES - RESPONSIVIDAD
   ============================================ */

/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */
@media (max-width: 1024px) {
  .pagina-historico.contenedorprincipal {
    width: 98%;
  }

  .pagina-historico .botonessuperiores {
    flex-wrap: wrap;
  }

  .pagina-historico .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.8rem;
    padding: 0.25rem !important;
  }

  .pagina-historico .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.85rem;
    padding: 0.25rem !important;
    height: 36px !important;
  }
}

/* === TABLETS (768px y menores) === */
@media (max-width: 768px) {
  .pagina-historico.contenedorprincipal {
    width: 100%;
    padding: 5px;
  }

  .pagina-historico .titulo {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }

  .pagina-historico .botonessuperiores {
    flex-direction: column;
    gap: 8px;
  }

  .pagina-historico .botonessuperiores .p-button {
    width: 100%;
    justify-content: center;
  }

  .pagina-historico .p-datatable-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 350px;
  }
}

/* === MÓVILES PEQUEÑOS (480px y menores) === */
@media (max-width: 480px) {
  .pagina-historico .titulo {
    font-size: 1rem;
  }

  .pagina-historico .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.75rem;
    padding: 0.2rem !important;
  }

  .pagina-historico .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.75rem;
    padding: 0.2rem !important;
    height: 32px !important;
  }
}

/* Forzar que la tabla ocupe el espacio restante en modales */
.full-height-table {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.full-height-table .p-datatable-wrapper {
  flex-grow: 1;
  height: 100% !important; /* Forzar altura total */
  max-height: 100% !important;
}

.p-dialog-content {
  display: flex !important;
  flex-direction: column;
  height: 100%;
}

/* === REFINAMIENTO MODAL HISTÓRICO: ESTILOS COMPACTOS === */
.historico-dialog .p-dialog-content {
  padding: 0.5rem !important; /* Reducir padding drásticamente */
}

.historico-dialog .table-historico-nested {
  padding: 0.5rem !important;
  margin: 0.5rem 0 !important;
}

/* Filas más compactas específicamente para este modal histórico */
.historico-dialog .p-datatable .p-datatable-tbody > tr > td {
  padding: 0.2rem 0.5rem !important;
  height: auto !important; /* Permitir altura mínima según contenido */
}
`, "",{"version":3,"sources":["webpack://./src/styles/Historico.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,4CAA4C;EAC3D,uBAAuB,EAAE,0CAA0C;EACnE,QAAQ,EAAE,gCAAgC;EAC1C,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,iBAAiB,EAAE,6CAA6C;EAChE,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE;IACE,gBAAgB,EAAE,kCAAkC;IACpD,gBAAgB,EAAE,0DAA0D;IAC5E,WAAW,EAAE,mCAAmC;EAClD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,yCAAyC;EACnD,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB,EAAE,wBAAwB;EACjD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,0BAA0B,EAAE,kCAAkC;AAChE;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,iCAAiC;EACjC,uBAAuB,EAAE,2CAA2C;AACtE","sourcesContent":[".pagina-historico.contenedorprincipal {\n  width: 95%;\n  margin: 0 auto;\n}\n\n.pagina-historico .titulo {\n  text-align: center;\n  margin-top: 0px;\n  margin-bottom: 2px;\n}\n\n.pagina-historico .botonessuperiores {\n  display: flex; /* Usamos flexbox para alinear los botones */\n  justify-content: center; /* Centramos los botones horizontalmente */\n  gap: 5px; /* Espaciado entre los botones */\n  margin-bottom: 15px; /* Espaciado inferior para separar de otros elementos */\n}\n\n.botonessuperiores .p-button {\n  padding: 5px 10px; /* Reduce el padding interno de los botones */\n  font-size: 14px; /* tamaño del texto de los botones*/\n}\n\n.fila-seleccionada {\n  background-color: #e0f7fa !important;\n}\n\n/*************Resumen estado pedidos***************/\n.resumen-estados-container {\n  position: absolute;\n  top: 60px;\n  right: 20px;\n  width: 250px;\n  padding: 5px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  font-size: 0.9rem;\n}\n\n/* Media query para pantallas pequeñas */\n@media (max-width: 768px) {\n  .resumen-estados-container {\n    position: static; /* Cambia la posición a estática */\n    margin-top: 20px; /* Agrega un margen superior para separar de los botones */\n    width: 100%; /* Ocupa todo el ancho disponible */\n  }\n}\n\n.resumen-estado-item {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* Espaciado entre el ícono y el nombre */\n  padding: 2px 0;\n}\n\n/* [EXPERT] Estabilidad del paginador y alineación */\n.pagina-historico .p-datatable .p-datatable-wrapper {\n  min-height: 400px;\n}\n\n.pagina-historico .p-datatable .p-datatable-thead > tr > th {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.35rem !important;\n}\n\n.pagina-historico .p-datatable .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.3rem !important;\n  height: 38px !important;\n}\n\n/* ============================================\n   MEDIA QUERIES - RESPONSIVIDAD\n   ============================================ */\n\n/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */\n@media (max-width: 1024px) {\n  .pagina-historico.contenedorprincipal {\n    width: 98%;\n  }\n\n  .pagina-historico .botonessuperiores {\n    flex-wrap: wrap;\n  }\n\n  .pagina-historico .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.8rem;\n    padding: 0.25rem !important;\n  }\n\n  .pagina-historico .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.85rem;\n    padding: 0.25rem !important;\n    height: 36px !important;\n  }\n}\n\n/* === TABLETS (768px y menores) === */\n@media (max-width: 768px) {\n  .pagina-historico.contenedorprincipal {\n    width: 100%;\n    padding: 5px;\n  }\n\n  .pagina-historico .titulo {\n    font-size: 1.2rem;\n    margin-bottom: 8px;\n  }\n\n  .pagina-historico .botonessuperiores {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .pagina-historico .botonessuperiores .p-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .pagina-historico .p-datatable-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 350px;\n  }\n}\n\n/* === MÓVILES PEQUEÑOS (480px y menores) === */\n@media (max-width: 480px) {\n  .pagina-historico .titulo {\n    font-size: 1rem;\n  }\n\n  .pagina-historico .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n  }\n\n  .pagina-historico .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n    height: 32px !important;\n  }\n}\n\n/* Forzar que la tabla ocupe el espacio restante en modales */\n.full-height-table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.full-height-table .p-datatable-wrapper {\n  flex-grow: 1;\n  height: 100% !important; /* Forzar altura total */\n  max-height: 100% !important;\n}\n\n.p-dialog-content {\n  display: flex !important;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* === REFINAMIENTO MODAL HISTÓRICO: ESTILOS COMPACTOS === */\n.historico-dialog .p-dialog-content {\n  padding: 0.5rem !important; /* Reducir padding drásticamente */\n}\n\n.historico-dialog .table-historico-nested {\n  padding: 0.5rem !important;\n  margin: 0.5rem 0 !important;\n}\n\n/* Filas más compactas específicamente para este modal histórico */\n.historico-dialog .p-datatable .p-datatable-tbody > tr > td {\n  padding: 0.2rem 0.5rem !important;\n  height: auto !important; /* Permitir altura mínima según contenido */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
